import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { MainsIcon } from "@thrivetribe/mvf.assets.icons.mains-icon";
import { TimeIcon } from "@thrivetribe/mvf.assets.icons.time-icon";
import { CaloriesIcon } from "@thrivetribe/mvf.assets.icons.calories-icon";
import React from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
} from "@thrivetribe/mvf.ui.molecules.card";
import "./recipe-card.scss";

const truncateString = (string: string, length: number) => {
  if (string.length > length) {
    return `${string.substring(0, length)}...`;
  }
  return string;
};

const basicPluralizeFunc = (
  singlarWord: string,
  amount?: number,
  showValue?: boolean
) => {
  if (amount) {
    if (amount === 1)
      return showValue ? `${amount} ${singlarWord}` : singlarWord;
    return showValue ? `${amount} ${singlarWord}s` : singlarWord + "s";
  }
  return singlarWord;
};

const formatTime = (time: string): string | undefined => {
  if (!time) return;
  const timeAsNum = Number(time.replace(/\D/g, ""));

  if (timeAsNum <= 60) {
    return `${timeAsNum} mins`;
  }

  const hours = Math.trunc(timeAsNum / 60);
  const mins = timeAsNum % 60;
  return `${hours} ${basicPluralizeFunc(
    "hr",
    hours
  )} ${mins} ${basicPluralizeFunc("min", mins)}`;
};

export type RecipeCardProps = {
  title: string;
  description: string;
  imgUrl: string;
  imgTitle: string;
  mealType?: string;
  time?: string;
  kCal?: string;
  onClick?: () => void;
};

export function RecipeCard({
  title,
  description,
  imgUrl,
  imgTitle,
  mealType,
  time,
  kCal,
  onClick,
}: RecipeCardProps) {
  return (
    <Card className="recipe-card" onClick={onClick}>
      <CardMedia imgUrl={imgUrl} imgTitle={imgTitle} />
      <CardContent
        title={truncateString(title, 30)}
        description={truncateString(description, 80)}
      >
        <div className="recipe-card__icons">
          {mealType && (
            <div className="recipe-card__icon-item">
              <MainsIcon />
              <p>{mealType}</p>
            </div>
          )}
          {time && (
            <div className="recipe-card__icon-item">
              <TimeIcon />
              <p>{formatTime(time)}</p>
            </div>
          )}
          {kCal && (
            <div className="recipe-card__icon-item">
              <CaloriesIcon />
              <p className="recipe-card__last-item">{kCal} kcal per serving</p>
            </div>
          )}
        </div>
      </CardContent>
      <CardActions>
        <Button variant="text" tabIndex={-1} onClick={onClick}>
          Read more <ButtonArrow />
        </Button>
      </CardActions>
    </Card>
  );
}
